import React, { useMemo } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import InspectionAssistantInsightsV2Dashboard from './components/InspectionAssistantInsightsV2Dashboard';
import './styles.scss';
function InspectionAssistantInsightsV2({ ipaScorecard = false }) {
    const queryClient = useMemo(() => new QueryClient(), []);
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(InspectionAssistantInsightsV2Dashboard, { ipaScorecard: ipaScorecard })));
}
export default InspectionAssistantInsightsV2;
